export const LED_BY_OPTIONS = {
  om_lifeline: 'OML',
  health_system: 'HS',
  lifeline_for_community: 'LfC',
  community: 'CO',
  lifeline_for_health_system: 'LfH',
  national_gpo: 'GPO'
}
export const LED_BY_LABEL = {
  om_lifeline: 'OM Lifeline',
  health_system: 'Health System',
  lifeline_for_community: 'Lifeline for Community',
  community: 'Community',
  lifeline_for_health_system: 'Lifeline for Health System',
  national_gpo: 'GPO'
}
export const LED_BY_VALUE = {
  OM_LIFELINE: 'om_lifeline',
  HEALTH_SYSTEM: 'health_system',
  LIFELINE_FOR_COMMUNITY: 'lifeline_for_community',
  COMMUNITY: 'community',
  LIFELINE_FOR_HEALTH_SYSTEM: 'lifeline_for_health_system',
  NATIONAL_GPO: 'national_gpo'
}
